import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import applicantService from "./applicantService";

const initialState = {
  data: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "", 

  dataID: [],
  isErrorID: false,
  isSuccessID: false,
  isLoadingID: false,
  messageID: "", 

  dataapp: [],
  isErrorapp: false,
  isSuccessapp: false,
  isLoadingapp: false,
  messageapp: "",
  errorapp: "",

  assigndata: [],
  assignisError: false,
  assignisSuccess: false,
  assignisLoading: false,
  assignmessage: "", 

  Screeningdata: [],
  ScreeningisError: false,
  ScreeningisSuccess: false,
  ScreeningisLoading: false,
  Screeningmessage: "", 

  Evalvationdata: [],
  EvalvationisError: false,
  EvalvationisSuccess: false,
  EvalvationisLoading: false,
  Evalvationmessage: "", 

  applicationassigneddata: [],
  applicationassignedisError: false,
  applicationassignedisSuccess: false,
  applicationassignedisLoading: false,
  applicationassignedmessage: "", 

  sendEmaildata: [],
  sendEmailisError: false,
  sendEmailisSuccess: false,
  sendEmailisLoading: false,
  sendEmailmessage: "", 

  shareApplicationdata: [],
  shareApplicationisError: false,
  shareApplicationisSuccess: false,
  shareApplicationisLoading: false,
  shareApplicationmessage: "", 

  scheduleApplicantdata: [],
  scheduleApplicantisError: false,
  scheduleApplicantisSuccess: false,
  scheduleApplicantisLoading: false,
  scheduleApplicantmessage: "", 

  UpdateScreeningStatusdata: [],
  UpdateScreeningStatusisError: false,
  UpdateScreeningStatusisSuccess: false,
  UpdateScreeningStatusisLoading: false,
  UpdateScreeningStatusmessage: "", 

 UpdateEvaluatingStatusdata: [],
 UpdateEvaluatingStatusisError: false,
 UpdateEvaluatingStatusisSuccess: false,
 UpdateEvaluatingStatusisLoading: false,
  UpdateEvaluatingStatusmessage: "", 
 
 UpdateOfferdata: [],
 UpdateOfferisError: false,
 UpdateOfferisSuccess: false,
 UpdateOfferisLoading: false,
 UpdateOffermessage: "", 
 
 updateInterviewStatusdata: [],
 updateInterviewStatusisError: false,
 updateInterviewStatusisSuccess: false,
 updateInterviewStatusisLoading: false,
 updateInterviewStatusmessage: "", 
 
  
 applicationInterviewdata: [],
 applicationInterviewisError: false,
 applicationInterviewisSuccess: false,
 applicationInterviewisLoading: false,
 applicationInterviewmessage: "", 
 

 sendOfferdata: [],
 sendOfferisError: false,
 sendOfferisSuccess: false,
 sendOfferisLoading: false,
 sendOffermessage: "", 
 

 updateApplicationInterviewStatusdata: [],
 updateApplicationInterviewStatusisError: false,
 updateApplicationInterviewStatusisSuccess: false,
 updateApplicationInterviewStatusisLoading: false,
 updateApplicationInterviewStatusmessage: "", 
 

 applicantDashboardDatadata: [],
 applicantDashboardDataisError: false,
 applicantDashboardDataisSuccess: false,
 applicantDashboardDataisLoading: false,
 applicantDashboardDatamessage: "", 
 
 dropoutToScreeningdata: [],
 dropoutToScreeningisError: false,
 dropoutToScreeningisSuccess: false,
 dropoutToScreeningisLoading: false,
  dropoutToScreeningmessage: "", 
 
 sendForHiredata: [],
 sendForHireisError: false,
 sendForHireisSuccess: false,
 sendForHireisLoading: false,
  sendForHiremessage: "", 
 

  Editapplicantiondata:   [],
  EditapplicantionisError: false,
  EditapplicantionisSuccess: false,
  EditapplicantionisLoading: false, 
  Editapplicantionmessage: '', 

  sendForTranningdata:   [],
  sendForTranningisError: false,
  sendForTranningisSuccess: false,
  sendForTranningisLoading: false, 
  sendForTranningmessage: '', 


  updateTranningdata:   [],
  updateTranningisError: false,
  updateTranningisSuccess: false,
  updateTranningisLoading: false, 
  updateTranningmessage: '', 

  ResignApplicantdata:   [],
  ResignApplicantisError: false,
  ResignApplicantisSuccess: false,
  ResignApplicantisLoading: false, 
  ResignApplicantmessage: '', 
};

// Get all jobs
export const getallapplicant = createAsyncThunk(
  "applicant/getallapplicant",
  async (input, thunkAPI) => {
    try {
      return await applicantService.getallApplicant(input);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Get all applicant by ID
export const getallapplicantbyID = createAsyncThunk(
  "applicant/getallapplicantbyID",
  async (id, thunkAPI) => {
    try {
      return await applicantService.getallapplicantbyID(id);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Applicant Post
export const applicantPost = createAsyncThunk(
  "applicant/applicantPost",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.applicantPost(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

 
export const assignNewScreening = createAsyncThunk(
  "applicant/assignNewScreening",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.assignNewScreening(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const dropoutToScreening = createAsyncThunk(
  "applicant/dropoutToScreening",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.dropoutToScreening(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Evalvation New Applicant
export const assignNewEvalvation = createAsyncThunk(
  "applicant/assignNewEvalvation",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.assignNewEvalvation(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Application Assigned
export const applicationassigned = createAsyncThunk(
  "applicant/applicationassigned",
  async (id, thunkAPI) => {
    try {
      return await applicantService.applicationassigned(id);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Send Email
export const sendEmail = createAsyncThunk(
  "applicant/sendEmail",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.sendEmail(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Share Application
export const shareApplication = createAsyncThunk(
  "applicant/shareApplication",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.shareApplication(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Schedule Applicant
export const scheduleApplicant = createAsyncThunk(
  "applicant/scheduleApplicant",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.scheduleApplicant(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//update applicant Screening status

export const UpdateScreeningStatus = createAsyncThunk(
  "applicant/UpdateScreeningStatus",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.UpdateScreeningStatus(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const UpdateEvaluatingStatus = createAsyncThunk(
  "applicant/UpdateEvaluatingStatus",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.UpdateEvaluatingStatus(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const UpdateOffer = createAsyncThunk(
  "applicant/UpdateOffer",
  async (inputs, thunkAPI) => {
    try {
      return await applicantService.UpdateOffer(inputs);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const updateInterviewStatus = createAsyncThunk(
  "applicant/updateInterviewStatus",
  async (data, thunkAPI) => {
    try {
      return await applicantService.updateInterviewStatus(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const applicationInterview = createAsyncThunk(
  "applicant/applicationInterview",
  async (data, thunkAPI) => {
    try {
      return await applicantService.applicationInterview(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const sendOffer = createAsyncThunk(
  "applicant/sendOffer",
  async (data, thunkAPI) => {
    try {
      return await applicantService.sendOffer(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const sendForTranning = createAsyncThunk(
  "applicant/sendForTranning",
  async (data, thunkAPI) => {
    try {
      return await applicantService.sendForTranning(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateApplicationInterviewStatus = createAsyncThunk(
  "applicant/updateApplicationInterviewStatus",
  async (data, thunkAPI) => {
    try {
      return await applicantService.updateApplicationInterviewStatus(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const applicantDashboardData = createAsyncThunk(
  "applicant/applicantDashboardData",
  async (data, thunkAPI) => {
    try {
      return await applicantService.applicantDashboardData();
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const sendForHire = createAsyncThunk(
  "applicant/sendForHire",
  async (data, thunkAPI) => {
    try {
      return await applicantService.sendForHire(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const EditApplication = createAsyncThunk(
  "applicant/EditApplication",
  async (data, thunkAPI) => {
    try {
      return await applicantService.EditApplication(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateTranning = createAsyncThunk(
  "applicant/updateTranning",
  async (data, thunkAPI) => {
    try {
      return await applicantService.updateTranning(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const ResignApplicant = createAsyncThunk(
  "applicant/ResignApplicant",
  async (data, thunkAPI) => {
    try {
      return await applicantService.ResignApplicant(data);
    } catch (error: any) {
      const message =
        error.response && error.response.data
          ? error.response.data.errors[0].message
          : error.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const applicantSlice = createSlice({
  name: "applicant",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";

      state.isLoadingID = false;
      state.isSuccessID = false;
      state.isErrorID = false;
      state.messageID = "";

      state.isLoadingapp = false;
      state.isSuccessapp = false;
      state.isErrorapp = false;
      state.messageapp = "";

      state.assignisLoading = false;
      state.assignisSuccess = false;
      state.assignisError = false;
      state.assignmessage = "";

      state.ScreeningisLoading = false;
      state.ScreeningisSuccess = false;
      state.ScreeningisError = false;
      state.Screeningmessage = "";

      state.EvalvationisLoading = false;
      state.EvalvationisSuccess = false;
      state.EvalvationisError = false;
      state.Evalvationmessage = "";

      state.applicationassignedisLoading = false;
      state.applicationassignedisSuccess = false;
      state.applicationassignedisError = false;
      state.applicationassignedmessage = "";

      state.sendEmailisLoading = false;
      state.sendEmailisSuccess = false;
      state.sendEmailisError = false;
      state.sendEmailmessage = "";

      state.shareApplicationisLoading = false;
      state.shareApplicationisSuccess = false;
      state.shareApplicationisError = false;
      state.shareApplicationmessage = "";

      state.scheduleApplicantisLoading = false;
      state.scheduleApplicantisSuccess = false;
      state.scheduleApplicantisError = false;
      state.scheduleApplicantmessage = "";

      state.UpdateScreeningStatusisError = false;
      state.UpdateScreeningStatusisSuccess = false;
      state.UpdateScreeningStatusisLoading = false;
      state.UpdateScreeningStatusmessage = "";

      state.UpdateEvaluatingStatusisError = false;
      state.UpdateEvaluatingStatusisSuccess = false;
      state.UpdateEvaluatingStatusisLoading = false;
      state.UpdateEvaluatingStatusmessage = "";


      state.UpdateOfferisError = false;
      state.UpdateOfferisSuccess = false;
      state.UpdateOfferisLoading = false;
      state.UpdateOffermessage = "";

      state.updateInterviewStatusisError = false;
      state.updateInterviewStatusisSuccess = false;
      state.updateInterviewStatusisLoading = false;
      state.updateInterviewStatusmessage = "";


      state.applicationInterviewisError = false;
      state.applicationInterviewisSuccess = false;
      state.applicationInterviewisLoading = false;
      state.applicationInterviewmessage = "";

      state.sendOfferisError = false;
      state.sendOfferisSuccess = false;
      state.sendOfferisLoading = false;
      state.sendOffermessage = "";

      state.updateApplicationInterviewStatusisError = false;
      state.updateApplicationInterviewStatusisSuccess = false;
      state.updateApplicationInterviewStatusisLoading = false;
      state.updateApplicationInterviewStatusmessage = "";

      
      state.applicantDashboardDataisError = false;
      state.applicantDashboardDataisSuccess = false;
      state.applicantDashboardDataisLoading = false;
      state.applicantDashboardDatamessage = "";

      state.dropoutToScreeningisError = false;
      state.dropoutToScreeningisSuccess = false;
      state.dropoutToScreeningisLoading = false;
      state.dropoutToScreeningmessage = "";

      state.sendForHireisError = false;
      state.sendForHireisSuccess = false;
      state.sendForHireisLoading = false;
      state.sendForHiremessage = "";
      
      state.sendForTranningisError = false;
      state.sendForTranningisSuccess = false;
      state.sendForTranningisLoading = false;
      state.sendForTranningmessage = "";

      state.EditapplicantionisError = false;
      state.EditapplicantionisSuccess = false;
      state.EditapplicantionisLoading = false;
      state.Editapplicantionmessage = "";

      state.updateTranningisError = false;
      state.updateTranningisSuccess = false;
      state.updateTranningisLoading = false;
      state.updateTranningmessage = "";

      state.ResignApplicantisError = false;
      state.ResignApplicantisSuccess = false;
      state.ResignApplicantisLoading = false;
      state.ResignApplicantmessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getallapplicant.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getallapplicant.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getallapplicant.rejected, (state: any, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.data = [];
      })
      .addCase(getallapplicantbyID.pending, (state) => {
        state.isLoadingID = true;
      })
      .addCase(getallapplicantbyID.fulfilled, (state, action) => {
        state.isLoadingID = false;
        state.isSuccessID = true;
        state.dataID = action.payload;
      })
      .addCase(getallapplicantbyID.rejected, (state: any, action) => {
        state.isLoadingID = false;
        state.isErrorID = true;
        state.messageID = action.payload;
        state.dataID = [];
      })

      .addCase(applicantPost.pending, (state) => {
        state.isLoadingapp = true;
      })
      .addCase(applicantPost.fulfilled, (state, action) => {
        state.isLoadingapp = false;
        state.isSuccessapp = true;
        state.dataapp = action.payload;
      })
      .addCase(applicantPost.rejected, (state: any, action) => {
        state.isLoadingapp = false;
        state.isErrorapp = true;
        state.messageapp = action.payload;
        state.dataapp = [];
      })

      .addCase(assignNewScreening.pending, (state) => {
        state.ScreeningisLoading = true;
      })
      .addCase(assignNewScreening.fulfilled, (state, action) => {
        state.ScreeningisLoading = false;
        state.ScreeningisSuccess = true;
        state.Screeningdata = action.payload;
      })
      .addCase(assignNewScreening.rejected, (state: any, action) => {
        state.ScreeningisLoading = false;
        state.ScreeningisError = true;
        state.Screeningmessage = action.payload;
        state.Screeningdata = [];
      })

      .addCase(dropoutToScreening.pending, (state) => {
        state.dropoutToScreeningisLoading = true;
      })
      .addCase(dropoutToScreening.fulfilled, (state, action) => {
        state.dropoutToScreeningisLoading = false;
        state.dropoutToScreeningisSuccess = true;
        state.dropoutToScreeningdata = action.payload;
      })
      .addCase(dropoutToScreening.rejected, (state: any, action) => {
        state.dropoutToScreeningisLoading = false;
        state.dropoutToScreeningisError = true;
        state.dropoutToScreeningmessage = action.payload;
        state.dropoutToScreeningdata = [];
      })

      .addCase(sendForHire.pending, (state) => {
        state.sendForHireisLoading = true;
      })
      .addCase(sendForHire.fulfilled, (state, action) => {
        state.sendForHireisLoading = false;
        state.sendForHireisSuccess = true;
        state.sendForHiredata = action.payload;
      })
      .addCase(sendForHire.rejected, (state: any, action) => {
        state.sendForHireisLoading = false;
        state.sendForHireisError = true;
        state.sendForHiremessage = action.payload;
        state.sendForHiredata = [];
      })

      .addCase(assignNewEvalvation.pending, (state) => {
        state.EvalvationisLoading = true;
      })
      .addCase(assignNewEvalvation.fulfilled, (state, action) => {
        state.EvalvationisLoading = false;
        state.EvalvationisSuccess = true;
        state.Evalvationdata = action.payload;
      })
      .addCase(assignNewEvalvation.rejected, (state: any, action) => {
        state.EvalvationisLoading = false;
        state.EvalvationisError = true;
        state.Evalvationmessage = action.payload;
        state.Evalvationdata = [];
      })

      .addCase(applicationassigned.pending, (state) => {
        state.applicationassignedisLoading = true;
      })
      .addCase(applicationassigned.fulfilled, (state, action) => {
        state.applicationassignedisLoading = false;
        state.applicationassignedisSuccess = true;
        state.applicationassigneddata = action.payload;
      })
      .addCase(applicationassigned.rejected, (state: any, action) => {
        state.applicationassignedisLoading = false;
        state.applicationassignedisError = true;
        state.applicationassignedmessage = action.payload;
        state.applicationassigneddata = [];
      })

      // Send Email
      .addCase(sendEmail.pending, (state) => {
        state.sendEmailisLoading = true;
      })
      .addCase(sendEmail.fulfilled, (state, action) => {
        state.sendEmailisLoading = false;
        state.sendEmailisSuccess = true;
        state.sendEmaildata = action.payload;
      })
      .addCase(sendEmail.rejected, (state: any, action) => {
        state.sendEmailisLoading = false;
        state.sendEmailisError = true;
        state.sendEmailmessage = action.payload;
        state.sendEmaildata = [];
      })

      // Share Application
      .addCase(shareApplication.pending, (state) => {
        state.shareApplicationisLoading = true;
      })
      .addCase(shareApplication.fulfilled, (state, action) => {
        state.shareApplicationisLoading = false;
        state.shareApplicationisSuccess = true;
        state.shareApplicationdata = action.payload;
      })
      .addCase(shareApplication.rejected, (state: any, action) => {
        state.shareApplicationisLoading = false;
        state.shareApplicationisError = true;
        state.shareApplicationmessage = action.payload;
        state.shareApplicationdata = [];
      })

      // Schedule Applicant
      .addCase(scheduleApplicant.pending, (state) => {
        state.scheduleApplicantisLoading = true;
      })
      .addCase(scheduleApplicant.fulfilled, (state, action) => {
        state.scheduleApplicantisLoading = false;
        state.scheduleApplicantisSuccess = true;
        state.scheduleApplicantdata = action.payload;
      })
      .addCase(scheduleApplicant.rejected, (state: any, action) => {
        state.scheduleApplicantisLoading = false;
        state.scheduleApplicantisError = true;
        state.scheduleApplicantmessage = action.payload;
        state.scheduleApplicantdata = [];
      })

      // Update Screening Status
      .addCase(UpdateScreeningStatus.pending, (state) => {
        state.UpdateScreeningStatusisLoading = true;
      })
      .addCase(UpdateScreeningStatus.fulfilled, (state, action) => {
        state.UpdateScreeningStatusisLoading = false;
        state.UpdateScreeningStatusisSuccess = true;
        state.UpdateScreeningStatusdata = action.payload;
      })
      .addCase(UpdateScreeningStatus.rejected, (state: any, action) => {
        state.UpdateScreeningStatusisLoading = false;
        state.UpdateScreeningStatusisError = true;
        state.UpdateScreeningStatusmessage = action.payload;
        state.UpdateScreeningStatusdata = [];
      })

      // Update Evaluating Status 
      .addCase(UpdateEvaluatingStatus.pending, (state) => {
        state.UpdateEvaluatingStatusisLoading = true;
      })
      .addCase(UpdateEvaluatingStatus.fulfilled, (state, action) => {
        state.UpdateEvaluatingStatusisLoading = false;
        state.UpdateEvaluatingStatusisSuccess = true;
        state.UpdateEvaluatingStatusdata = action.payload;
      })
      .addCase(UpdateEvaluatingStatus.rejected, (state: any, action) => {
        state.UpdateEvaluatingStatusisLoading = false;
        state.UpdateEvaluatingStatusisError = true;
        state.UpdateEvaluatingStatusmessage = action.payload;
        state.UpdateEvaluatingStatusdata = [];
      })
      // Update Offer
      .addCase(UpdateOffer.pending, (state) => {
        state.UpdateOfferisLoading = true;
      })
      .addCase(UpdateOffer.fulfilled, (state, action) => {
        state.UpdateOfferisLoading = false;
        state.UpdateOfferisSuccess = true;
        state.UpdateOfferdata = action.payload;
      })
      .addCase(UpdateOffer.rejected, (state: any, action) => {
        state.UpdateOfferisLoading = false;
        state.UpdateOfferisError = true;
        state.UpdateOffermessage = action.payload;
        state.UpdateOfferdata = [];
      })

      // Update Interview Status  
      .addCase(updateInterviewStatus.pending, (state) => {
        state.updateInterviewStatusisLoading = true;
      })
      .addCase(updateInterviewStatus.fulfilled, (state, action) => {
        state.updateInterviewStatusisLoading = false;
        state.updateInterviewStatusisSuccess = true;
        state.updateInterviewStatusdata = action.payload;
      })
      .addCase(updateInterviewStatus.rejected, (state: any, action) => {
        state.updateInterviewStatusisLoading = false;
        state.updateInterviewStatusisError = true;
        state.updateInterviewStatusmessage = action.payload;
        state.updateInterviewStatusdata = [];
      })
      // Application Interview 
      .addCase(applicationInterview.pending, (state) => {
        state.applicationInterviewisLoading = true;
      })
      .addCase(applicationInterview.fulfilled, (state, action) => {
        state.applicationInterviewisLoading = false;
        state.applicationInterviewisSuccess = true;
        state.applicationInterviewdata = action.payload;
      })
      .addCase(applicationInterview.rejected, (state: any, action) => {
        state.applicationInterviewisLoading = false;
        state.applicationInterviewisError = true;
        state.applicationInterviewmessage = action.payload;
        state.applicationInterviewdata = [];
      })

      // Send Offer 
      .addCase(sendOffer.pending, (state) => {
        state.sendOfferisLoading = true;
      })
      .addCase(sendOffer.fulfilled, (state, action) => {
        state.sendOfferisLoading = false;
        state.sendOfferisSuccess = true;
        state.sendOfferdata = action.payload;
      })
      .addCase(sendOffer.rejected, (state: any, action) => {
        state.sendOfferisLoading = false;
        state.sendOfferisError = true;
        state.sendOffermessage = action.payload;
        state.sendOfferdata = [];
      })
      
      // Send Offer 
      .addCase( updateApplicationInterviewStatus.pending, (state) => {
        state.updateApplicationInterviewStatusisLoading = true;
      })
      .addCase( updateApplicationInterviewStatus.fulfilled, (state, action) => {
        state.updateApplicationInterviewStatusisLoading = false;
        state.updateApplicationInterviewStatusisSuccess = true;
        state.updateApplicationInterviewStatusdata = action.payload;
      })
      .addCase( updateApplicationInterviewStatus.rejected, (state: any, action) => {
        state.updateApplicationInterviewStatusisLoading = false;
        state.updateApplicationInterviewStatusisError = true;
        state.updateApplicationInterviewStatusmessage = action.payload;
        state.updateApplicationInterviewStatusdata = [];
      })
    
    
       // Applicant Dashboard Data
      .addCase( applicantDashboardData.pending, (state) => {
        state.applicantDashboardDataisLoading = true;
      })
      .addCase( applicantDashboardData.fulfilled, (state, action) => {
        state.applicantDashboardDataisLoading = false;
        state.applicantDashboardDataisSuccess = true;
        state.applicantDashboardDatadata = action.payload;
      })
      .addCase( applicantDashboardData.rejected, (state: any, action) => {
        state.applicantDashboardDataisLoading = false;
        state.applicantDashboardDataisError = true;
        state.applicantDashboardDatamessage = action.payload;
        state.applicantDashboardDatadata = [];
      })

       // Send For Tranning
      .addCase( sendForTranning.pending, (state) => {
        state.sendForTranningisLoading = true;
      })
      .addCase( sendForTranning.fulfilled, (state, action) => {
        state.sendForTranningisLoading = false;
        state.sendForTranningisSuccess = true;
        state.sendForTranningdata = action.payload;
      })
      .addCase( sendForTranning.rejected, (state: any, action) => {
        state.sendForTranningisLoading = false;
        state.sendForTranningisError = true;
        state.sendForTranningmessage = action.payload;
        state.sendForTranningdata = [];
      })
       // update Tranning
      .addCase( updateTranning.pending, (state) => {
        state.updateTranningisLoading = true;
      })
      .addCase( updateTranning.fulfilled, (state, action) => {
        state.updateTranningisLoading = false;
        state.updateTranningisSuccess = true;
        state.updateTranningdata = action.payload;
      })
      .addCase( updateTranning.rejected, (state: any, action) => {
        state.updateTranningisLoading = false;
        state.updateTranningisError = true;
        state.updateTranningmessage = action.payload;
        state.updateTranningdata = [];
      })

    
       // Applicant Dashboard Data
      .addCase( EditApplication.pending, (state) => {
        state.EditapplicantionisLoading = true;
      })
      .addCase( EditApplication.fulfilled, (state, action) => {
        state.EditapplicantionisLoading = false;
        state.EditapplicantionisSuccess = true;
        state.Editapplicantiondata = action.payload;
      })
      .addCase( EditApplication.rejected, (state: any, action) => {
        state.EditapplicantionisLoading = false;
        state.EditapplicantionisError = true;
        state.Editapplicantionmessage = action.payload;
        state.Editapplicantiondata = [];
      })
    
       // Resign Applicant Data
      .addCase( ResignApplicant.pending, (state) => {
        state.ResignApplicantisLoading = true;
      })
      .addCase( ResignApplicant.fulfilled, (state, action) => {
        state.ResignApplicantisLoading = false;
        state.ResignApplicantisSuccess = true;
        state.ResignApplicantdata = action.payload;
      })
      .addCase( ResignApplicant.rejected, (state: any, action) => {
        state.ResignApplicantisLoading = false;
        state.ResignApplicantisError = true;
        state.ResignApplicantmessage = action.payload;
        state.ResignApplicantdata = [];
      });
  },
});

export const { reset } = applicantSlice.actions;
export default applicantSlice.reducer;
